export default "__VITE_ASSET__BPvukArQ__"